/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from '@mui/styles';
import { neutral7 } from 'apollo-react/colors';
import LinearProgress from 'apollo-react/components/LinearProgress';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

const useStyles = makeStyles({
  linkContainer: {
    color: '#06C',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export const ResultName = ({ row }) => {
  const classes = useStyles();
  const { Label, Code, handleSearchByPredictionText } = row;
  return (
    <a
      onClick={(e) => {
        e.preventDefault();
        handleSearchByPredictionText(Code, Label);
      }}
      className={classes.linkContainer}
      style={{ textDecoration: 'none' }}
    >
      {Label}
    </a>
  );
};

export const Confidence = ({ row }) => {
  const { Conf } = row;
  const confidenceLevel = (Conf * 100).toFixed(2);
  return (
    <Typography variant="body2" style={{ color: neutral7 }}>{`${confidenceLevel}%`}</Typography>
  );
};

export const ConfidenceLevel = ({ row }) => {
  const { Conf } = row;
  const confidenceLevel = (Conf * 100).toFixed(2);
  return <LinearProgress variant="determinate" value={confidenceLevel} style={{ height: 8 }} />;
};
